import { createApiClient, type ApiClient, type TokenPair } from '@cuito/api-client';
import { useAuthStore } from '../stores/authStore';

/**
 * 全局单例 API 客户端。
 *
 * **必须全局唯一**：`createApiClient` 内部持有 `refreshPromise` 用于 401 单飞刷新，
 * 若每个模块各自创建实例，就会出现「多个实例同时刷新」，令牌轮换互相踩踏。
 * 因此这里导出一个实例，所有领域调用复用它。
 */
export const apiClient: ApiClient = createApiClient({
  baseURL: '/api',
  getTokens: (): TokenPair | null => {
    const { accessToken, refreshToken } = useAuthStore.getState();
    if (!accessToken || !refreshToken) return null;
    return { accessToken, refreshToken };
  },
  onTokens: (tokens) => {
    useAuthStore.getState().setTokens(tokens.accessToken, tokens.refreshToken);
  },
  onUnauthorized: () => {
    useAuthStore.getState().logout();
  },
});
